import React from 'react'
import { Icon } from '@iconify/react';
const AnalyticCard = ({ data }) => {
    return (
        <div className="row row-cols-xxxl-4 row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-1 gy-4">

            <div className="col">
                <div className="card shadow-none border bg-gradient-start-1">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">
                                    Instances
                                </p>
                                <h6 className="mb-0 fs-4">{data.activeInstances}</h6>
                            </div>
                            <div className="w-40-px h-40-px bg-success-main rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="logos:whatsapp-icon"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-2">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">
                                    Contacts
                                </p>
                                <h6 className="mb-0">{data.totalUsedContacts}</h6>
                            </div>
                            <div className="w-40-px h-40-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="mdi:account-box"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-3">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Campaign</p>
                                <h6 className="mb-0">{data.totalCampaign}</h6>
                            </div>
                            <div className="w-40-px h-40-px bg-red rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="mdi-bullhorn"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-4">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Templates</p>
                                <h6 className="mb-0">{data.totalUsedTemplates}</h6>
                            </div>
                            <div className="w-40-px h-40-px bg-secondary rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="fa6-solid:file-invoice-dollar"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="col">
                <div className="card shadow-none border bg-gradient-start-1 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Allowed Instances</p>
                                <h6 className="mb-0">{data.allowedInstance}</h6>
                            </div>
                            <div className="w-40-px h-40-px bg-success-main rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="logos:whatsapp-icon"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-3">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">
                                    Allowed Contacts
                                </p>
                                <h6 className="mb-0">{data.totalContacts}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="mdi:account-box"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-4 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Allowed Messages</p>
                                <h6 className="mb-0">{data.totalMsgs}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="bi:chat-dots"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-4 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Messages Remaining</p>
                                <h6 className="mb-0">{data.remainingMsgs}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="bi:chat-dots"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-4 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Sended in 30 Days</p>
                                <h6 className="mb-0">{data.totalMsgsSentInMonth}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="bi:chat-dots"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-5 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Allowed Templates</p>
                                <h6 className="mb-0">{data.totalTemplats}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-secondary rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="fa6-solid:file-invoice-dollar"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

        </div>

    )
}

export default AnalyticCard